import { useState, useEffect } from "react";
import Header from "../components/Partner/Header";
import PartnerSidebar from "../components/Partner/PartnerSidebar";
import CaseStudiesSection from "../components/Partner/CaseStudiesSection";
import PartnerFooter from "../components/Partner/PartnerFooter";

import CaseStudy1 from "../assets/case-study-1.jpg";
import CaseStudy2 from "../assets/case-study-2.png";
import CaseStudy3 from "../assets/case-study-3.png";
import CaseStudy4 from "../assets/case-study-4.png";
import CaseStudy5 from "../assets/case-study-5.png";

const caseStudies = [
  {
    id: "dipshit",
    name: "Dipshit",
    title: "Van Dinsdagavond Naar Fenomeen",
    image: CaseStudy1,
    description: (
      <>
        Dipshit is hét perfecte voorbeeld van hoe een slimme samenwerking en
        strategische timing voor structureel succes kunnen zorgen. Hun vaste
        dinsdagavond was al populair, maar samen hebben we er een waar fenomeen
        van gemaakt. Dankzij hun sterke marketingstrategie besloten zij bewust
        om niet pas op dinsdag uit te verkopen, maar al op maandagavond hun
        event op sold out te zetten. <br />
        <br />
        Dit was een strategische keuze: het creëerde de indruk dat Dipshit ruim
        van tevoren was uitverkocht, wat direct leidde tot extra vraag voor de
        weken daarna. Zo konden wij op dinsdag, via onze community, nog eens 110
        extra tickets verkopen. Niet alleen voor de huidige editie, maar ook als
        vliegwiel voor de volgende. De hype verspreidde zich snel, met als
        gevolg dat een grote groep bezoekers alvast hun tickets voor de volgende
        week veiligstelde. <br />
        <br />
        Dit bewijst hoe krachtig de combinatie is van slimme marketing, een
        loyale community en perfecte timing. Door samen te sturen op momentum,
        tillen we een wekelijkse editie naar structureel succes en blijven de
        zalen gevuld.
      </>
    ),
  },
  {
    id: "piv",
    name: "PIV Festival",
    title: "Extra Marketing Power",
    image: CaseStudy2,
    description: (
      <>
        PIV Festival is een geweldig voorbeeld van hoe wij bestaande
        marketingkanalen kunnen versterken voor nog meer impact. Hun eigen
        strategie stond al als een huis, maar door samen te werken met 22Night
        voegden we een extra laag toe die direct resultaat opleverde. Vanaf het
        eerste moment dat de campagne live ging, tot aan de allerlaatste ticket,
        waren wij onderdeel van hun marketingflow.
        <br />
        <br />
        We haakten in op elk belangrijk moment: van early birds tot line-up
        drops en de bekende bijna uitverkocht triggers. Dankzij onze community
        konden we snel schakelen en extra aandacht genereren wanneer dat nodig
        was. Zo hielpen wij PIV hun zichtbaarheid en urgentie op te schalen,
        waardoor ze moeiteloos door hun ticketvolumes heen gingen. Voor PIV
        betekende dit simpelweg: hun marketingkanalen werden via ons krachtiger,
        gerichter en vooral effectiever.
      </>
    ),
  },
  {
    id: "contra",
    name: "Contra w/ Bad Boombox",
    title: "Strak Uitverkocht",
    image: CaseStudy3,
    description: (
      <>
        Contra stond voor een uitdaging: hun eerste editie met de grote naam Bad
        Boombox moest impact maken, maar de kaartverkoop bleef achter op de
        verwachtingen. Daar sprongen wij direct op in. Met een creatieve Spin &
        Win actie in onze community gaven we maar liefst 300 gratis tickets weg.
        <br />
        <br />
        Onze leden gingen er massaal voor. Alle 300 codes werden binnen de
        kortste keren geclaimd. Maar wat nóg belangrijker is: de zaal stond
        uiteindelijk bomvol, en de sfeer was top. Dankzij de activatie hadden we
        niet alleen lege plekken gevuld, maar ook enorm veel zichtbaarheid voor
        Contra gecreëerd. Voor onze community was het een beleving op zich:
        gratis tickets winnen voor een topavond — precies wat 22Night tot leven
        brengt.
      </>
    ),
  },
  {
    id: "binnenstad",
    name: "Binnenstad",
    title: "De Perfecte Match",
    image: CaseStudy4,
    description: (
      <>
        Binnenstad laat zien hoe je met de juiste targeting structureel succes
        boekt. Bij elke editie zijn wij vanaf de start betrokken: vanaf het
        moment dat de tickets live gaan tot aan het uitverkopen van de zaal.
        Maar wat het echt bijzonder maakt, is de impact die we hebben op hun
        ticketverkoop. Inmiddels realiseren we via onze community tot wel 40%
        van hun totale sales.
        <br />
        <br />
        Wat hier zo goed werkt? Binnenstad weet precies hoe ze onze doelgroep
        moeten aanspreken. Hun concept sluit naadloos aan op wat onze leden
        zoeken, en dankzij de directe lijnen binnen onze community zorgen wij
        voor gerichte promotie die keihard converteert. Resultaat: volle zalen,
        keer op keer, én een partnership dat met elke editie sterker wordt.
      </>
    ),
  },
  {
    id: "stelz",
    name: "STËLZ Student Delivery Service",
    title: "Van Testcase Naar Instant Succes",
    image: CaseStudy5,
    description: (
      <>
        Dit was een strategische keuze: het creëerde de indruk dat Dipshit ruim
        van tevoren was uitverkocht, wat direct leidde tot extra vraag voor de
        weken daarna. Zo konden wij op dinsdag, via onze community, nog eens 110
        extra tickets verkopen. Niet alleen voor de huidige editie, maar ook als
        vliegwiel voor de volgende. De hype verspreidde zich snel, met als
        gevolg dat een grote groep bezoekers alvast hun tickets voor de volgende
        week veiligstelde. <br />
        <br />
        Dit bewijst hoe krachtig de combinatie is van slimme marketing, een
        loyale community en perfecte timing. Door samen te sturen op momentum,
        tillen we een wekelijkse editie naar structureel succes en blijven de
        zalen gevuld.
      </>
    ),
  },
];

export default function PartnersCaseStudies() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const id = new URLSearchParams(window.location.search).get("id");

  const caseStudy = caseStudies.find((caseStudy) => caseStudy.id === id);

  // Scroll to top when case study changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div
      className="bg-[#1D1726] min-h-screen"
      style={{
        background:
          "linear-gradient(to bottom, #0B0415 0%, #1d0630 40vh, #2a0744 60vh)",
      }}
    >
      <div className="mx-auto max-md:p-[20px] max-w-[1160px]">
        <Header setSidebarOpen={setSidebarOpen} />
      </div>

      {caseStudy && (
        <div className="max-md:p-[20px]">
          <div
            className="relative flex justify-center items-center md:mt-[12px] max-md:rounded-[16px] w-full h-[480px]"
            style={{
              backgroundImage: `url(${caseStudy.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 bg-[#0B041590]"></div>
            <div className="z-10 flex flex-col gap-[12px] text-center">
              <div className="font-semibold text-[48px] text-white leading-[52px] tracking-[-1px]">
                {caseStudy.name}
              </div>
              <div className="font-normal text-[26px] text-white leading-[32px]">
                {caseStudy.title}
              </div>
            </div>
          </div>
        </div>
      )}
      {caseStudy && (
        <div className="flex justify-center items-center max-md:p-[20px] py-[72px] w-full">
          <div className="max-w-[640px] text-[18px] text-white leading-[32px]">
            {caseStudy.description}
          </div>
        </div>
      )}
      <div className="bg-[#0B0415]">
        <div className="mx-auto max-md:p-[20px] max-w-[1160px]">
          <CaseStudiesSection fromDetailPage={true} exclude={caseStudy?.id} />
        </div>
      </div>
      <PartnerFooter />

      <PartnerSidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
    </div>
  );
}
